// extracted by mini-css-extract-plugin
module.exports = {"deliveries_top":"deliveries_top","deliveries_top__add_btn":"deliveries_top__add_btn","date_shift":"date_shift","date_shift__date":"date_shift__date"};